// @flow

import styled from 'styled-components';
import Cart from '@leasen_nl/listo/src/components/cart';
import type { Theme } from '@types/index';

export default styled<typeof Cart, Theme, _>(Cart)`
  margin-bottom: 1.5rem;
`;
